var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDialog',{ref:"dialog",attrs:{"tmpl":_vm.tmpl},on:{"Save":_vm.save,"Add":_vm.add,"Remove":_vm.remove}})
}
var staticRenderFns = []

export { render, staticRenderFns }